import styled from 'styled-components'
import { Swiper } from 'swiper/react'

import {
  IconButton,
  Select,
  SelectOption,
  TypeStyle,
  focusOutline,
  fromMd,
  withHoverSupport,
} from '@syconium/little-miss-figgy'

import {
  CrossedOutPrice,
  DiscountPrice,
  Price,
} from '../../../../../brunswick/components/PriceDisplay/styles'
import { swiperCSS } from '../../../../../lib/shared-styles'

export const AddButtonWrapper = styled.div`
  flex: 1;
`

export const Body = styled.div`
  ${swiperCSS}

  background: ${o => o.theme.color.fill.subtle};
  position: relative;
  overflow-x: hidden;
  padding: ${o => o.theme.spacing(8, 4, 0)};
`

export const LoadingSpinnerWrapper = styled.div`
  align-items: center;
  background-color: ${o => o.theme.color.fill.subtle};
  display: flex;
  height: 237px;
  justify-content: center;
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)`
  text-align: center;
`

export const DetailText = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.text.tertiary.on.background};
  font-size: 11px;
  font-weight: bold;
`

export const SwiperContainer = styled(Swiper)`
  background-color: ${o => o.theme.color.fill.subtle};
  margin: auto;

  & .swiper-wrapper {
    ${focusOutline}
  }

  & * {
    outline: none;
  }

  ${fromMd} {
    max-width: 400px;
  }

  & .swiper-pagination {
    position: static;
    text-align: center;
  }

  & .swiper-pagination-bullet {
    ${focusOutline}
    background-color: ${o =>
      o.theme.color.stroke.neutral.border.interaction.tertiary.on.background};
    border-radius: 100%;
    display: inline-block;
    height: ${o => o.theme.spacing(1)};
    margin: ${o => o.theme.spacing(1)};
    opacity: 1;
    width: ${o => o.theme.spacing(1)};
  }

  & .swiper-pagination-bullet-active {
    background-color: black;
    height: ${o => o.theme.spacing(2)};
    width: ${o => o.theme.spacing(2)};
    margin-bottom: ${o => o.theme.spacing(0.5)};
  }
`

export const Next = styled.button`
  /*
    Hidden by default (touch devices swipe / use the pagination dots). Shown only where
    a hover-capable, fine pointer exists — which includes desktop at high browser zoom,
    where the viewport reports as small but the user still needs mouse/keyboard controls.
  */
  display: none;
  position: absolute;
  inset-inline-end: 40px;
  top: 147px;
  z-index: 10000;

  ${withHoverSupport} {
    display: block;
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`

export const Back = styled.button`
  display: none;
  inset-inline-start: 40px;
  position: absolute;
  top: 147px;
  z-index: 10000;

  ${withHoverSupport} {
    display: block;
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`

export const UpsellTile = styled.div`
  background: ${o => o.theme.color.fill.background};
  margin: ${o => o.theme.spacing(4)};
  padding: ${o => o.theme.spacing(4)};
`

export const Thumbnail = styled.div<{
  imgUrl: string
}>`
  background: no-repeat center/contain url(${o => o.imgUrl && o.imgUrl});
  height: 84px;
  width: 83px;
  min-width: 83px;
`

export const TileOverview = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-inline-start: 16px;
  width: 100%;
`

export const SizeSelectorWrapper = styled.div`
  flex: 1;
  margin-inline-end: 5px;

  ${fromMd} {
    margin-inline-end: 10px;
  }
`

export const SizeSelector = styled(Select)`
  && {
    ${TypeStyle.css.bodySmall}
    height: 100%;
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }

  ${IconButton} {
    min-width: 24px;
    min-height: 24px;
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }
`

export const SizeSelectorOption = styled(SelectOption)`
  font-size: 13px;
`

export const ProductName = styled(TypeStyle.HeadlineExtraExtraSmall)`
  font-size: 13px;
  margin-bottom: ${o => o.theme.spacing(1)};
`

export const PriceAndColor = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${o => o.theme.spacing(1)};

  ${CrossedOutPrice},
  ${DiscountPrice},
  ${Price} {
    font-size: 11px;
    line-height: 1.5;
  }
`

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${o => o.theme.spacing(3)};
`
